import { lazy } from 'react';

import type { TApplicationRoute } from '@modules/core/types';

import { PROMO_ROUTE_PATHS } from './config';

export const PROMO_ROUTES: TApplicationRoute[] = [
  {
    id: 'movements-promo',
    path: PROMO_ROUTE_PATHS.promo,
    component: lazy(() => import('./pages/promo-page')),
    layout: 'default',
    permissions: { scopes: ['movements-promo'] },
    menu: {
      title: 'pages.movements.promo.title',
    },
  },
];
